import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query'

import { referenceKeys } from '@/features/reference/api/keys'
import { referenceService } from '@/features/reference/api/referenceService'
import type { MetricPresentations } from '@/schemas/reference'

/**
 * An hour. The presentation table is editorial — staff edit it in an admin,
 * on no schedule a member could notice inside a session — so one read serves
 * every Technical and Trading tab opened in that time. On the factory, not
 * the hook, because `prefetchRouteData` honours the query's OWN staleTime.
 */
const REFERENCE_STALE_MS = 60 * 60_000

/** Every metric's direction, bands and words, keyed by metric code. */
export const metricPresentationsQueryOptions = () =>
  queryOptions<MetricPresentations>({
    queryKey: referenceKeys.metricPresentations(),
    queryFn: () => referenceService.metricPresentations(),
    staleTime: REFERENCE_STALE_MS,
  })

/**
 * The table a reading is worded from. A failed or pending read is not a
 * reason to hide a figure: word what the table covers once it arrives, and
 * fall back to the screen's own reading until then.
 */
export const useMetricPresentations = (): UseQueryResult<MetricPresentations> =>
  useQuery(metricPresentationsQueryOptions())
